import { SOURCE_DISCOVERY_SKILL_ID } from '@rw/contracts';

export const CHAT_PAGE_CONTEXT = { stage: 'brief', surface: 'chat' } as const;

export const COMPOSER_FIELD_SELECTOR = 'textarea.ui-chat-input-field';

export const TERMINAL_AGENT_STATUSES = new Set(['completed', 'failed', 'cancelled']);

export const WEB_SEARCH_SKILL_ID = SOURCE_DISCOVERY_SKILL_ID;
